var map = {
	"./Subtract.png": 1376,
	"./border.png": 1377,
	"./cancel.png": 1378,
	"./coupon-bg-not-login.png": 1379,
	"./coupon-gift-left-double.png": 1380,
	"./coupon-gift-left-one.png": 1381,
	"./coupon-gift-top.png": 1382,
	"./facebook-icon.png": 1383,
	"./google-icon.png": 1384,
	"./guide-header.png": 1126,
	"./login/facebook.png": 1385,
	"./login/google.png": 1116,
	"./login/vk.png": 1117,
	"./loginbtn-facebook.png": 1386,
	"./loginbtn-google.png": 1118,
	"./notice-background-header.png": 1387,
	"./submit.png": 1388
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2007;